/* Product rail: arrows and a progress rule.
 *
 * The rail scrolls natively; this only adds affordances. Without them a
 * half-visible card reads as an overflow bug rather than an invitation.
 */

class HsRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.prail');
    this.prev = this.querySelector('[data-rail-prev]');
    this.next = this.querySelector('[data-rail-next]');
    this.bar = this.querySelector('[data-rail-progress]');
    if (!this.track) return;

    this.prev?.addEventListener('click', () => this.#page(-1));
    this.next?.addEventListener('click', () => this.#page(1));

    this.onScroll = () => {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.#sync());
    };
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.#sync();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    cancelAnimationFrame(this.raf);
  }

  #page(dir) {
    // One card plus its gap, so a click always lands on a card edge.
    const card = this.track.querySelector(':scope > *');
    const step = card ? card.getBoundingClientRect().width + 2 : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: step * dir, behavior: 'smooth' });
  }

  #sync() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const x = this.track.scrollLeft;
    if (this.prev) this.prev.disabled = x < 4;
    if (this.next) this.next.disabled = x > max - 4;
    if (this.bar) {
      // The thumb's width is the share of the rail currently visible, and it
      // travels the remaining track as the rail scrolls. Both are expressed
      // as percentages of the parent so the rule always spans its container,
      // whatever that container's width turns out to be.
      const visible = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
      const travelled = max > 0 ? x / max : 0;
      const w = Math.max(visible, 0.15);
      this.bar.style.width = `${w * 100}%`;
      this.bar.style.transform = `translateX(${(travelled * (1 - w) * 100) / w}%)`;
    }
  }
}

if (!customElements.get('hs-rail')) customElements.define('hs-rail', HsRail);
